import { getEditorPreloader } from '@confluence-classic/confluence-fabric-editor/src/lib';

import { LazyHome } from '@confluence/home/entry-points/LazyHome';
import { LazyOverview } from '@confluence/home/entry-points/LazyOverview';
import {
	SiteHomepageRedirectLoader,
	GoToHomeLoader,
} from '@confluence/home/entry-points/HomeRedirects';

export const preloadHome = ({ name, params }) => {
	getEditorPreloader();
	GoToHomeLoader.preload();

	if (name === 'WIKI') {
		SiteHomepageRedirectLoader.preload();
	}

	LazyHome.preload();

	if (params.view === 'undefined' || typeof params.view === 'undefined' || name === 'WIKI') {
		LazyOverview.preload();
	}
};
